export default __webpack_public_path__ + "static/Metal_Railing-caf40f12699a6c491c0008cd6714b83d.png";